module.exports = __webpack_public_path__ + "acb878a397bf674d7baa32a3267e5a3c.ttf";